import {
  COST_CALCULATOR_FETCH_REQUEST,
  COST_CALCULATOR_FETCH_SUCCESS,
  COST_CALCULATOR_FETCH_FAILURE,
  COST_CALCULATOR_SUBMIT_REQUEST,
  COST_CALCULATOR_SUBMIT_SUCCESS,
  COST_CALCULATOR_SUBMIT_FAILURE
} from '../actions/costCalculatorActions';

// Status carries a state alongside the data (idle|pending|succeeded|failed) — never inferred
// from emptiness, per GPX React Rule 2. `error` gates the initial load (nothing on screen yet);
// `submitError` is a non-gating banner for a failed save/send while the calculator the user has
// been editing stays fully on screen.
const initialState = {
  status: 'idle',
  data: null,
  error: null,
  submitStatus: 'idle',
  submitError: null,
  lastSubmitResponse: null
};

const costCalculatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case COST_CALCULATOR_FETCH_REQUEST:
      return {...state, status: 'pending', error: null};

    case COST_CALCULATOR_FETCH_SUCCESS:
      return {...state, status: 'succeeded', data: action.payload, error: null};

    case COST_CALCULATOR_FETCH_FAILURE:
      return {...state, status: 'failed', error: action.payload};

    case COST_CALCULATOR_SUBMIT_REQUEST:
      return {...state, submitStatus: 'pending', submitError: null};

    case COST_CALCULATOR_SUBMIT_SUCCESS:
      return {
        ...state,
        submitStatus: 'succeeded',
        submitError: null,
        lastSubmitResponse: action.payload
      };

    case COST_CALCULATOR_SUBMIT_FAILURE:
      return {...state, submitStatus: 'failed', submitError: action.payload};

    default:
      return state;
  }
};

export default costCalculatorReducer;
